import styled from "styled-components";
import { breakpoints, sizes } from "styles";

export const PriceListWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 51px 80px 40px;
  gap: 10px;
  background: #d7e3fc;

  @media ${breakpoints.mobile} {
    padding: 48px 24px;
    gap: 16px;
  }
`;

export const PriceListContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: ${sizes.containerWidth};
  width: 100%;
  margin: 0 auto;
`;

export const PriceListTitle = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  font-size: 34px;
  line-height: normal;
  color: #252b46;
  margin: 0;
  text-align: center;

  @media ${breakpoints.mobile} {
    font-size: 24px;
  }
`;

export const PriceListSubtitle = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: 400;
  font-size: 16px;
  line-height: normal;
  color: #4d5470;
  margin: 0;
  text-align: center;

  @media ${breakpoints.mobile} {
    font-size: 14px;
  }
`;

export const PriceGrid = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  padding-top: 30px;
  overflow: clip;
  align-items: flex-start;

  @media ${breakpoints.mobile} {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
`;

export const PriceCard = styled.div<{ $bgColor?: string }>`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  padding: 24px 32px;
  background: ${({ $bgColor }) => $bgColor || "#1e5af6"};
  border-radius: 16px;
  overflow: clip;
`;

export const PriceCardHead = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  font-size: 19px;
  line-height: 1.2;
  color: white;
  text-align: center;
  margin: 0;
  width: 100%;
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  background: white;
  border-radius: 12px;
  padding: 12px 14px;
  overflow: hidden;
`;

export const PriceRowPlan = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  flex: 1;
  min-width: 0;
`;

export const PriceRowPlanName = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 600;
  font-size: 13.5px;
  line-height: 1.25;
  color: #252b46;
  margin: 0;
`;

export const PriceRowPlanDesc = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: 400;
  font-size: 11px;
  line-height: 1.3;
  color: #4d5470;
  margin: 0;
  white-space: pre-wrap;
`;

export const PriceRowAmount = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  white-space: nowrap;
`;

export const PriceRowPrice = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  font-size: 16px;
  line-height: normal;
  color: #1e5af6;
  margin: 0;
`;

export const PriceRowPeriod = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: 400;
  font-size: 10.5px;
  line-height: normal;
  color: #4d5470;
  margin: 0;
`;

export const PriceCardNote = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: 400;
  font-size: 8px;
  line-height: 1.3;
  color: white;
  text-align: center;
  margin: 0;
  width: 100%;
`;

export const PriceListCTAWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 26px;
`;

export const PriceListCTAButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px 28px 13px;
  background: #0bb876;
  border: none;
  border-radius: 14px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }

  span {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-weight: 600;
    font-size: 16px;
    line-height: normal;
    color: white;
  }
`;
